import { render, staticRenderFns } from "./CompareTOCVersionOptions.vue?vue&type=template&id=1fb7d4da"
import script from "./CompareTOCVersionOptions.vue?vue&type=script&lang=js"
export * from "./CompareTOCVersionOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports